import DefaultLayout from "../layouts/DefaultLayout"

function Nothing() {
    return <DefaultLayout></DefaultLayout>
}

export default Nothing